import _BaseAPIService from "./_BaseAPIService";

  const apiService = _BaseAPIService.instance;
const PartnerService = {
  getList: async () => {
    const response = await apiService.get("/partners");
    return response.data;
  },
  // getbyId: async (id) => {
  //   const response = await apiService.get(`/menu/${id}`);
  //   return response.data;
  // },
    
}

export default PartnerService
